/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum ClaimListFilterColumnEnum {
    PARTNER = 'PARTNER',
    SUPPLYING_PACKING_PLANT = 'SUPPLYING_PACKING_PLANT',
    LAST_CHANGE_DATETIME = 'LAST_CHANGE_DATETIME',
    LOT_NUMBER = 'LOT_NUMBER',
    NUMBER = 'CLAIM_NUMBER',
    MATERIAL = 'MATERIAL',
    STATUS = 'STATUS',
    SENT_DATE = 'SENT_DATE',
    REFERENCE_NUMBER = 'REFERENCE_NUMBER',
    MODEL_TYPE = 'MODEL_TYPE',
    MODEL_CODE = 'MODEL_CODE',
    CLAIM_CODE = 'CLAIM_CODE'
}
